module.exports = __webpack_public_path__ + "img/40_37_026_610.565bdb6d.jpg";